// Marvel-style jumbo text: product images hard-cut through the letterforms.
class JumboFlicker extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('.jumbo-flicker__text');
    const data = this.querySelector('[data-jumbo-images]');
    if (!this.text || !data) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    try {
      this.urls = JSON.parse(data.textContent).filter(Boolean);
    } catch {
      return;
    }
    if (this.urls.length < 2) return;
    this.interval = parseInt(this.dataset.interval, 10) || 500;
    this.index = 0;
    this.loaded = [];
    // Preload; start once at least two frames are ready
    this.urls.forEach((u, i) => {
      const img = new Image();
      img.onload = () => {
        this.loaded[i] = u;
        if (this.loaded.filter(Boolean).length === 2) this.start();
      };
      img.src = u;
    });
    this.observer = new IntersectionObserver((entries) => {
      this.visible = entries[0].isIntersecting;
    });
    this.observer.observe(this);
  }

  start() {
    if (this.timer) return;
    this.timer = setInterval(() => {
      if (this.visible === false || document.hidden) return;
      const ready = this.loaded.filter(Boolean);
      if (!ready.length) return;
      this.index = (this.index + 1) % ready.length;
      this.text.style.backgroundImage = `url("${ready[this.index]}")`;
    }, this.interval);
    const first = this.loaded.find(Boolean);
    if (first) this.text.style.backgroundImage = `url("${first}")`;
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    this.observer?.disconnect();
  }
}
if (!customElements.get('jumbo-flicker')) customElements.define('jumbo-flicker', JumboFlicker);
